<template>
    <div class="row">
        <div class="col-md-12 pl-3 pr-3">
            <div class="row">
                <div :class="getSliderRowClass()" v-for="question in value.slider">
                    <div class="card h-100 query-result-container">
                        <div class="d-flex justify-content-between">
                            <div class="my-auto p-2 hide-overflow">
                                {{question.title | languageString}}
                            </div>
                            <div class="my-auto pr-1">
                                <status-indicator :value="question.answer" :trend="question.trend" full-width/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div :class="getTextRowClass()" v-for="question in value.text">
                    <div class="card col-sm-12 h-100">
                        <div class="card-body">
                            <div class="col-sm-12">
                                <b>{{question.title | languageString}}</b>
                            </div>
                            <hr>
                            <div class="text">
                                <p v-if="question.answer" v-html="$options.filters.changeToBr(question.answer)"></p>
                                <p v-else><center>___</center></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import StatusIndicator from '../../Dashboard/Components/StatusIndicator'

  export default {
    name: 'BasicQueryResult',
    components: { StatusIndicator },
    props: {
      value: {
        type: Object
      }
    },
    methods: {
      getSliderRowClass: function () {
        const length = this.value.slider.length
        let className = 'p-1 '

        if (length === 1) {
          className += 'col-lg-12 col-md-12 col-sm-12'
        } else if (length === 2) {
          className += 'col-lg-6 col-md-6 col-sm-6'
        } else if (length === 3) {
          className += 'col-lg-4 col-md-6 col-sm-6'
        } else if (length >= 4) {
          className += 'col-lg-3 col-md-6 col-sm-6'
        }
        return className
      },
      getTextRowClass: function () {
        const length = this.value.text.length
        let className = 'p-1 '

        if (length === 1) {
          className += 'col-xl-12 col-lg-12 col-md-12 col-sm-12'
        } else if (length === 2) {
          className += 'col-xl-6 col-lg-6 col-md-12 col-sm-12'
        } else if (length === 3) {
          className += 'col-xl-6 col-lg-6 col-md-12 col-sm-12'
        } else if (length >= 4) {
          className += 'col-xl-6 col-lg-6 col-md-12 col-sm-12'
        }
        return className
      }
    }
  }
</script>

<style lang="scss">
    .result-inline {
        display: inline-block;
    }
    .h-100 {
        height: 100%;
    }
    .query-result-container {
        display: flex;
        justify-content: center;
    }
    .hide-overflow {
      overflow: hidden;
    }
</style>
